<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue'
import store from '@/store'
import { useRouter } from 'vue-router'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Table, TableHeader, TableBody, TableRow, TableCell } from '@/components/ui/table'
import { Button } from '@/components/ui/button'
import { TableCard, TableEmptyState } from '@/components/common/table'

const router = useRouter()
const currentOrder = computed(() => store.state.currentOrder)
const items = ref([] as any[])

async function refreshData() {
  items.value = JSON.parse(currentOrder.value.items)
}

function redirectTo(routeName: string, mailItemDescription: string) {
  let id: string | null = null

  id = mailItemDescription.match(/\d+/)?.[0] || null

  router.push({ name: routeName, params: { id: id } })
}

onMounted(async () => {
  await refreshData()
})
</script>

<template>
  <TableCard title="Zásielky">
    <div class="max-w-full overflow-x-auto min-w-0">
      <Card class="max-w-2xl mx-auto">
        <CardHeader class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex items-center gap-3">
            <svg class="size-6 text-pink-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" title="Zásielky">
              <rect x="3" y="5" width="18" height="14" rx="3" stroke="currentColor" stroke-width="2" fill="none" />
              <path d="M3 7l9 6 9-6" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>
            <CardTitle class="text-xl font-bold text-gray-900 dark:text-white/90" title="Popis objednávky">{{ currentOrder.description }}</CardTitle>
          </div>
          <span class="text-xl font-bold text-brand-700" title="Celková suma">{{ currentOrder.amount }}€</span>
        </CardHeader>
        <CardContent class="flex flex-col gap-4">
          <div class="flex items-center gap-2">
            <svg class="size-5 text-brand-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" title="Zoznam zásielok">
              <rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" stroke-width="2" fill="none" />
              <path d="M8 12h8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
            <span class="font-semibold text-gray-700 dark:text-gray-300">Zoznam zásielok</span>
          </div>
          <Table class="min-w-full divide-y divide-gray-100 dark:divide-gray-800">
            <TableBody>
              <TableRow v-for="item in items" :key="item.description" class="hover:bg-brand-50 transition">
                <TableCell class="pr-8 py-2 text-gray-800 dark:text-white/90">{{ item.description }}</TableCell>
                <TableCell>
                  <Button
                    v-if="!item.description.includes('sídla')"
                    variant="default"
                    size="sm"
                    @click="redirectTo('Detail zásielky', item.description)"
                    title="Prejsť na zásielku"
                    class="gap-2"
                  >
                    <svg class="size-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                    <span class="sr-only">Prejsť na zásielku</span>
                  </Button>
                </TableCell>
              </TableRow>
              <TableEmptyState
                v-if="items.length === 0"
                title="Žiadne zásielky neboli nájdené"
                hint=""
                colspan="2"
              />
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  </TableCard>
</template>